import {
  BaseRecord,
  HttpError,
  IResourceComponentsProps,
} from "@refinedev/core";
import { Edit, useForm } from "@refinedev/mantine";
import { Select } from "@mantine/core";
import { CreateLike } from "entities/like";
import UserSelect from "components/users/UserSelect";
import { isNotEmpty } from "@mantine/form";
import { selectLikableTypes } from "entities/like/likable_type";
import ArticleSelect from "components/articles/ArticleSelect";
import CommentSelect from "components/comments/CommentSelect";

export const LikeEdit: React.FC<IResourceComponentsProps> = () => {
  const {
    getInputProps,
    saveButtonProps,
    setFieldValue,
    values,
    errors,
    refineCore: { queryResult },
  } = useForm<BaseRecord, HttpError, CreateLike>({
    refineCoreProps: {
      redirect: "show",
    },
    initialValues: {
      likable_id: undefined,
      likable_type: "WordpressArticle",
      user_id: undefined,
    },
    validate: {
      user_id: isNotEmpty(),
      likable_id: isNotEmpty(),
    },
  });

  const user = queryResult?.data?.data?.user;
  const likable = queryResult?.data?.data?.likable;

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <UserSelect
        defaultValue={user?.id}
        value={values.user_id}
        onChange={(userId) => setFieldValue("user_id", userId)}
      />
      <Select
        placeholder="Channel"
        data={selectLikableTypes}
        label="Likable Type"
        clearable={false}
        {...getInputProps("likable_type")}
      />
      {values.likable_type === "WordpressArticle" && (
        <ArticleSelect
          label="Article to like"
          defaultValue={likable?.id}
          value={values.likable_id}
          onChange={(articleId) => setFieldValue("likable_id", articleId)}
        />
      )}
      {values.likable_type === "Comment" && (
        <CommentSelect
          label="Comment to like"
          defaultValue={likable?.id}
          value={values.likable_id}
          onChange={(commentId) => setFieldValue("likable_id", commentId)}
        />
      )}
    </Edit>
  );
};
